"use strict";
Object.defineProperties(exports, { __esModule: { value: true }, [Symbol.toStringTag]: { value: "Module" } });
const index = require("./index.js");
const hooks = require("./hooks.js");
const webStorage = require("./web-storage-1mQqDY5f.js");
exports.default = index.default;
exports.useLocalStorage = hooks.useLocalStorage;
exports.useSessionStorage = hooks.useSessionStorage;
exports.COOKIE_STORAGE = webStorage.COOKIE_STORAGE;
exports.EXPIRE_DAY = webStorage.EXPIRE_DAY;
exports.EXPIRE_MONTH = webStorage.EXPIRE_MONTH;
exports.EXPIRE_YEAR = webStorage.EXPIRE_YEAR;
exports.LOCAL_STORAGE = webStorage.LOCAL_STORAGE;
exports.SESSION_STORAGE = webStorage.SESSION_STORAGE;
exports.STATE_MANAGEMENT = webStorage.STATE_MANAGEMENT;
